import { Text } from '@delmonicos/shared-design-system-react/src/components/typography/text/text';
import { TransactionModel } from '@delmonicos/shared-sdk/libs/cpms/src/libs/charge-hub-service-lib/src/wrapper/outputs/transaction/paginated/transaction.model';
import { CellContext } from '@tanstack/react-table';

export interface TransactionListTokenTypeCellProps
  extends CellContext<
    TransactionModel,
    NonNullable<TransactionModel['token']>['type'] | undefined
  > {}

export const TransactionListTokenTypeCell = (
  props: TransactionListTokenTypeCellProps,
): React.JSX.Element => {
  // CONTEXT ///////////////////////////////////////////////////////////////////

  const { getValue } = props;

  // RENDER ////////////////////////////////////////////////////////////////////

  return <Text truncate>{getValue()}</Text>;
};
